/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { FunctionComponent } from "react";

import { StrapiContactItem } from "@/types/strapi";

import { ButtonVariantKeys } from "@/tokens/configs/button_config";
import { Spacing } from "@/tokens/spacing";

import { Button } from "@/ui/atoms/button";
import { Icon } from "@/ui/atoms/icon";
import { Text } from "@/ui/atoms/text";

import { RichText } from "./rich_text";

export const ContactItem: FunctionComponent<StrapiContactItem> = (
    props: StrapiContactItem,
) => {
    /**
     * Styles
     */
    const contactItemContainerStyles = css({
        alignItems: "flex-start",
        display: "flex",
        flexDirection: "column",
        padding: `${Spacing["spacing-8"]} 0`,
    });

    const iconStyles = css({
        marginBottom: Spacing["spacing-4"],
        padding: Spacing["spacing-4"],
    });

    const ctaStyles = css({
        display: "inline-block",
    });

    /**
     * Elements
     */
    return (
        <div css={contactItemContainerStyles}>
            {props.Icon && (
                <Icon
                    className={iconStyles}
                    color="green-60"
                    renderContainer={true}
                    size={32}
                    slug={props.Icon}
                />
            )}

            <Text fontSize="ContactHeadlineSecondary" tag="h2">
                {props.Title}
            </Text>

            <RichText config="Longform">{props.Description}</RichText>

            {props.CTA && (
                <Button
                    className={ctaStyles}
                    fontSize="ContactCTA"
                    href={props.CTA.URL}
                    marginTop="ContactItemCTAMarginTop"
                    variant={
                        props.CTA.Appearance.toLowerCase() as ButtonVariantKeys
                    }
                >
                    {props.CTA.Text}
                </Button>
            )}
        </div>
    );
};
